export { default as HighlightKeyword } from './highlight-keyword';
